import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { calculateScore } from './scoring';
import Select from 'react-select';
import { topPlayers } from './topPlayers_101';
import { Filter } from 'bad-words';
const filter = new Filter();
import logo from './Assets/logo.png';
import { collection, getDocs, getDoc, doc, setDoc, serverTimestamp, deleteDoc } from 'firebase/firestore';
import { auth, db } from './firebase';
import players from './players.json';
import html2canvas from 'html2canvas';
import { AuthProvider, useAuth } from './context/AuthContext';
import AppLinkContent from './components/AppLinkContent';
import Account from './Account';
import PastLeaderboard from "./PastLeaderboard";



function AppContent() {
  const { user, loading } = useAuth();
const draftLockDate = new Date("2026-04-23T20:00:00-04:00");
const isLocked = new Date() > draftLockDate;
const [timeLeft, setTimeLeft] = useState("");

useEffect(() => {
  const updateCountdown = () => {
    const now = new Date();
    const diff = draftLockDate - now;

    if (diff <= 0) {
      setTimeLeft("🔒 Draft has started — picks are locked.");
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    setTimeLeft(
      `⏳ ${days}d ${hours}h ${minutes}m ${seconds}s until the 2026 NFL Draft`
    );
  };

  updateCountdown();
  const timer = setInterval(updateCountdown, 1000);

  return () => clearInterval(timer);
}, []);
useEffect(() => {
  console.log("👤 Firebase User:", user);
  console.log("⏳ Loading state:", loading);
}, [user, loading]);




  const initialDraftOrder = [
  "Las Vegas Raiders",
  "New York Jets",
  "Arizona Cardinals",
  "Tennessee Titans",
  "New York Giants",
  "Cleveland Browns",
  "Washington Commanders",
  "New Orleans Saints",
  "Kansas City Chiefs",
  "New York Giants",
  "Miami Dolphins",
  "Dallas Cowboys",
  "Los Angeles Rams",
  "Baltimore Ravens",
  "Tampa Bay Buccaneers",
  "New York Jets",
  "Detroit Lions",
  "Minnesota Vikings",
  "Carolina Panthers",
  "Dallas Cowboys",
  "Pittsburgh Steelers",
  "Los Angeles Chargers",
  "Philadelphia Eagles",
  "Cleveland Browns",
  "Chicago Bears",
  "Buffalo Bills",
  "San Francisco 49ers",
  "Houston Texans",
  "Kansas City Chiefs",
  "Miami Dolphins",
  "New England Patriots",
  "Seattle Seahawks"
];

  const [picks, setPicks] = useState(Array(32).fill(''));
const [teams, setTeams] = useState(initialDraftOrder);

useEffect(() => {
  const loadUserDraftData = async () => {
    if (!user) return;

    try {
      const userRef = doc(db, "users", user.email);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const data = userSnap.data();
        setPicks(data.picks_2026 || Array(32).fill(''));
        setTeams(data.teams_2026 || initialDraftOrder);
      }
    } catch (err) {
      console.error("Error loading 2026 picks:", err);
    }
  };

  loadUserDraftData();
}, [user]);

  if (loading) {
  return <div className="text-center text-lg font-bold text-gray-600">Loading...</div>;
}
  function Home() {
    return <h2 className="text-lg font-semibold">Welcome to DraftChallenge! Predict the full 1st round of the Draft and compete for the top spot.</h2>;
  }
  

  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <nav className="bg-white shadow p-4 flex flex-col lg:flex-row items-center justify-center lg:justify-between gap-4">
          <div className="flex flex-col items-center lg:flex-row gap-2">
            <img src={logo} alt="Draft Challenge Logo" className="h-16 w-auto" />
            <h1 className="text-xl font-bold text-center lg:text-left" style={{ color: '#003f8f' }}>
              DraftChallenge.App
            </h1>
            <div className="text-sm font-semibold text-green-700 text-center">
  {timeLeft}
</div>
          </div>

          

          <div className="flex flex-wrap gap-4 justify-center mt-4 lg:mt-0">
<AppLinkContent />

            <>
  <Link to="/instructions" style={{ color: '#003f8f' }} className="hover:underline">Instructions</Link>
  <Link to="/players" style={{ color: '#003f8f' }} className="hover:underline">Players</Link>
  <Link to="/draft" style={{ color: '#003f8f' }} className="hover:underline whitespace-nowrap">Make&nbsp;Picks</Link>
  <Link to="/summary" style={{ color: '#003f8f' }} className="hover:underline whitespace-nowrap">My&nbsp;Picks</Link>
  <Link to="/leaderboard" style={{ color: '#003f8f' }} className="hover:underline">Leaderboard</Link>
</>

            

            {user?.email === 'levibaldridge@gmail.com' && (
  <Link to="/admin">Admin</Link>
)}


          </div>
        </nav>

        <div className="p-6">
          <Routes>
          <Route path="/past-leaderboard" element={<PastLeaderboard />} />
            <Route path="/instructions" element={<Instructions />} />
            <Route path="/players" element={<Players />} />
            <Route
  path="/draft"
  element={<Draft picks={picks} setPicks={setPicks} teams={teams} setTeams={setTeams} />}
/>
            <Route path="/summary" element={<Summary picks={picks} teams={teams} />} />
            <Route path="/leaderboard" element={<Leaderboard user={user} />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/account" element={<Account />} />

            
            <Route path="*" element={<Home />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}


function Players() {
  const [search, setSearch] = useState("");
  const [filteredPlayers, setFilteredPlayers] = useState(players);

  useEffect(() => {
    const lowerSearch = search.toLowerCase().trim();
  
    const positionAliases = {
      safety: "S",
      safeties: "S",
      saf: "S",               // partial match for "safety"
      cornerback: "CB",
      cb: "CB",
      edge: "EDGE",
      linebacker: "LB",
      line: "LB",             // partial match
      defensive: "DL",
      tackle: "OT",
      guard: "OG",
      center: "C",
      qb: "QB",
      rb: "RB",
      wr: "WR",
      te: "TE",
    };
  
    // Match exact or partial alias key
    const aliasKey = Object.keys(positionAliases).find(key =>
      lowerSearch.startsWith(key)
    );
  
    const alias = aliasKey ? positionAliases[aliasKey] : null;
  
    const filtered = players.filter((player) => {
      const nameMatch = player.name.toLowerCase().includes(lowerSearch);
      const schoolMatch = player.school.toLowerCase().includes(lowerSearch);
      const positionMatch = player.position.toLowerCase().includes(lowerSearch);
      const aliasMatch = alias && player.position.toLowerCase() === alias.toLowerCase();
  
      return nameMatch || schoolMatch || positionMatch || aliasMatch;
    });
  
    setFilteredPlayers(filtered);
  }, [search]);
  
  
    

  return (
    <>
      <div className="sticky top-0 bg-white z-40 flex justify-center py-2 shadow-sm border-b">
        <Link to="/draft" className="text-[#003f8f] font-semibold hover:underline">
          📝 Back to Make Picks
        </Link>
      </div>

      <div className="p-4 max-w-5xl mx-auto">
        <h1 className="text-2xl font-bold mb-4 text-center text-[#003f8f]">2026 Draft Prospects</h1>
        <input
          type="text"
          placeholder="Search by name, position, or school"
          className="w-full p-2 mb-6 border border-gray-300 rounded-md"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        {filteredPlayers.length === 0 ? (
          <p className="text-center text-red-500">No players match your search.</p>
        ) : (
          <div className="grid sm:grid-cols-2 gap-4">
            {filteredPlayers.map((player) => (
              <div key={player.rank} className="border rounded-xl p-4 shadow-md bg-white">
                <h2 className="text-lg font-semibold text-[#003f8f]">
                  {player.name} <span className="text-sm text-gray-500">({player.position})</span>
                </h2>
                <p className="text-sm text-gray-600">Rank: {player.rank} | {player.school}</p>
                <p className="text-sm text-gray-600">Height: {player.height} | Weight: {player.weight} lbs</p>
                <p className="mt-2 text-sm">{player.trimmed_blurb}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}










function Instructions() {
  return (
    <div className="max-w-3xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4 text-center text-[#003f8f]">📖 How to Play</h1>
      <ul className="list-disc pl-6 space-y-3 text-base">
        <li>
          <strong>Sign Up or Sign In</strong><br />
          Think you can outpick the competition? Create an account to prove it.
        </li>

        <li>
          <strong>Go to the “Make Picks” Tab</strong><br />
          Predict the 1st round of the NFL Draft by selecting:
          <ul className="list-disc pl-6 mt-1">
            <li>The <strong>team</strong> making each pick (to support trades)</li>
            <li>The <strong>player</strong> you think will be selected</li>
          </ul>
        </li>

        <li>
          <strong>Player Dropdown Tips</strong><br />
          Players already picked show a ❌ and appear grayed out.<br />
          You <strong>can still select them</strong> to <em>swap</em>, <em>replace</em>, or <em>cancel</em> — the app will help you resolve any conflicts automatically.
        </li>

        <li>
          <strong>Team Dropdown Tips</strong><br />
          Teams can be selected more than once to account for trades.<br />
          If you pick a team already used, you’ll get a smart <em>Swap</em>, <em>Replace</em>, or <em>Cancel</em> popup.
        </li>

        <li>
          <strong>Saving Picks</strong><br />
          Scroll to the bottom of the “Make Picks” tab and click <strong>“Submit Picks”</strong> to save them to the leaderboard.<br />
          You must be signed in to submit your picks.
        </li>

        <li>
          <strong>Restore Submitted Picks</strong><br />
          Already submitted picks can be restored if you make changes you don’t like. Just click <strong>“Restore Submitted Picks”</strong> at the top of the Draft tab.
        </li>

        <li>
          <strong>Switching Tabs?</strong><br />
          You can freely switch between tabs — your current picks are automatically saved locally until submitted.
        </li>

        <li>
          <strong>⏰ Picks Lock at Draft Time</strong><br />
          All picks become <span className="text-red-600 font-semibold">locked</span> when the NFL Draft starts on <strong>April 23, 2026 at 8:00 PM ET</strong>.<br />
          No changes allowed after that time.
        </li>

        <li>
          <strong>📋 View and Share Your Picks</strong><br />
          Go to the <strong>“My Picks" </strong> tab to see a clean summary of your predictions.<br />
          You can <strong>download</strong>, <strong>copy</strong>, or <strong>share</strong> your picks with friends — and even copy the app link to invite others to play!
        </li>
      </ul>

      <h2 className="text-2xl font-bold mt-10 mb-4 text-center text-[#003f8f]">🏆 How Scoring Works</h2>
      <p className="mb-4">
        After the real draft picks are entered by the admin, your predictions are scored based on how close you were:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li><strong>+5 points</strong> – Correct team</li>
        <li><strong>+5 points</strong> – Exact pick number</li>
        <li><strong>+4 points</strong> – Off by 1 pick</li>
        <li><strong>+3 points</strong> – Off by 2 picks</li>
        <li><strong>+2 points</strong> – Off by 3 picks</li>
        <li><strong>+1 point</strong> – Off by 4 picks</li>
      </ul>

      <p className="mt-4 italic">
        Example:<br />
        You picked Drake Maye to go #4 to the Cardinals.<br />
        He actually goes #3 to the Patriots.<br />
        ✅ Off by 1 pick = <strong>4 points</strong><br />
        ❌ Wrong team = <strong>0 points</strong><br />
        → <strong>4 points total</strong>
      </p>

      <h2 className="text-2xl font-bold mt-10 mb-4 text-center text-[#003f8f]">📊 Leaderboard</h2>
      <p className="text-base mb-2">
        After the draft begins, the leaderboard will show each user's score and allow you to click their username to see their full pick breakdown.
      </p>
    </div>
  );
}














function Draft({ picks, setPicks, teams, setTeams }) {
  const { user } = useAuth();
  const allTeams = [
    "Arizona Cardinals",
    "Atlanta Falcons",
    "Baltimore Ravens",
    "Buffalo Bills",
    "Carolina Panthers",
    "Chicago Bears",
    "Cincinnati Bengals",
    "Cleveland Browns",
    "Dallas Cowboys",
    "Denver Broncos",
    "Detroit Lions",
    "Green Bay Packers",
    "Houston Texans",
    "Indianapolis Colts",
    "Jacksonville Jaguars",
    "Kansas City Chiefs",
    "Las Vegas Raiders",
    "Los Angeles Chargers",
    "Los Angeles Rams",
    "Miami Dolphins",
    "Minnesota Vikings",
    "New England Patriots",
    "New Orleans Saints",
    "New York Giants",
    "New York Jets",
    "Philadelphia Eagles",
    "Pittsburgh Steelers",
    "San Francisco 49ers",
    "Seattle Seahawks",
    "Tampa Bay Buccaneers",
    "Tennessee Titans",
    "Washington Commanders"
  ];

  const teamNeeds = {
    "Las Vegas Raiders": ["QB", "WR", "OL"],
    "New York Jets": ["QB", "EDGE", "WR"],
    "Arizona Cardinals": ["QB", "OL", "EDGE"],
    "Tennessee Titans": ["OL", "EDGE", "WR"],
    "New York Giants": ["DL", "OL", "CB"],
    "Cleveland Browns": ["QB", "OL", "WR"],
    "Washington Commanders": ["WR", "EDGE", "OL"],
    "New Orleans Saints": ["WR", "EDGE", "CB"],
    "Kansas City Chiefs": ["CB", "WR", "EDGE"],
    "Miami Dolphins": ["WR", "CB", "EDGE"],
    "Dallas Cowboys": ["EDGE", "LB", "CB"],
    "Los Angeles Rams": ["WR", "OL", "LB"],
    "Baltimore Ravens": ["OL", "WR", "EDGE"],
    "Tampa Bay Buccaneers": ["EDGE", "CB", "LB"],
    "Detroit Lions": ["OL", "EDGE", "S"],
    "Minnesota Vikings": ["DL", "OL", "S"],
    "Carolina Panthers": ["OL", "S", "WR"],
    "Pittsburgh Steelers": ["QB", "OL", "WR"],
    "Los Angeles Chargers": ["OL", "EDGE", "DL"],
    "Philadelphia Eagles": ["EDGE", "OL", "S"],
    "Chicago Bears": ["S", "OL", "EDGE"],
    "Buffalo Bills": ["EDGE", "OL", "LB"],
    "San Francisco 49ers": ["OL", "EDGE", "WR"],
    "Houston Texans": ["OL", "DL", "LB"],
    "New England Patriots": ["EDGE", "OL", "DL"],
    "Seattle Seahawks": ["RB", "OL", "CB"],

    "Jacksonville Jaguars": ["DL", "CB", "S"],
    "Indianapolis Colts": ["TE", "OL", "LB"],
    "Atlanta Falcons": ["EDGE", "DL", "CB"],
    "Cincinnati Bengals": ["EDGE", "S", "LB"],
    "Denver Broncos": ["RB", "WR", "CB"],
    "Green Bay Packers": ["CB", "WR", "EDGE"]
  };

  const teamOptions = [...allTeams]
    .sort((a, b) => a.localeCompare(b))
    .map(team => ({
      value: team,
      label: `${team} – Needs: ${(teamNeeds[team] || []).join(", ")}`
    }));

  const initialDraftOrder = [
    "Las Vegas Raiders",
    "New York Jets",
    "Arizona Cardinals",
    "Tennessee Titans",
    "New York Giants",
    "Cleveland Browns",
    "Washington Commanders",
    "New Orleans Saints",
    "Kansas City Chiefs",
    "New York Giants",
    "Miami Dolphins",
    "Dallas Cowboys",
    "Los Angeles Rams",
    "Baltimore Ravens",
    "Tampa Bay Buccaneers",
    "New York Jets",
    "Detroit Lions",
    "Minnesota Vikings",
    "Carolina Panthers",
    "Dallas Cowboys",
    "Pittsburgh Steelers",
    "Los Angeles Chargers",
    "Philadelphia Eagles",
    "Cleveland Browns",
    "Chicago Bears",
    "Buffalo Bills",
    "San Francisco 49ers",
    "Houston Texans",
    "Kansas City Chiefs",
    "Miami Dolphins",
    "New England Patriots",
    "Seattle Seahawks"
  ];

  const [submitted, setSubmitted] = useState(false);
  const [submittedData, setSubmittedData] = useState({ picks: [], teams: [] });
  const [teamConflict, setTeamConflict] = useState(null);
  const [showTeamModal, setShowTeamModal] = useState(false);
  const [playerConflict, setPlayerConflict] = useState(null);
  const [showPlayerModal, setShowPlayerModal] = useState(false);

  useEffect(() => {
    if (user) {
      const fetchUserData = async () => {
        const docRef = doc(db, "users", user.email);
        const userSnap = await getDoc(docRef);

        if (userSnap.exists()) {
          const data = userSnap.data();
          setPicks(data.picks_2026 || Array(32).fill(""));
          setTeams(data.teams_2026 || initialDraftOrder);
        } else {
          localStorage.removeItem("draftPicks_temp");
          localStorage.removeItem("draftTeams_temp");
          setPicks(Array(32).fill(""));
          setTeams(initialDraftOrder);
        }
      };

      fetchUserData();
    }
  }, [user]);

  useEffect(() => {
    const fetchSubmittedData = async () => {
      if (!user) return;
      try {
        const userDoc = await getDoc(doc(db, "users", user.email));
        if (userDoc.exists()) {
          const data = userDoc.data();
          setSubmittedData({
            picks: data.picks_2026 || [],
            teams: data.teams_2026 || [],
          });
        }
      } catch (err) {
        console.error("Failed to load submitted picks:", err);
      }
    };

    fetchSubmittedData();
  }, [user]);

  useEffect(() => {}, [teams]);

  useEffect(() => {
    const fetchSubmittedStatus = async () => {
      if (!user) return;

      try {
        const userDoc = await getDoc(doc(db, "users", user.email));
        const data = userDoc.data();
        if (data?.submittedAt_2026) {
          setSubmitted(true);
        }
      } catch (err) {
        console.error("Error checking submission status:", err);
      }
    };

    fetchSubmittedStatus();
  }, [user]);

  useEffect(() => {}, [picks]);

  const playerOptions = topPlayers.map(player => ({
    value: player.name,
    label: `#${player.rank} [${player.position} #${player.positionRank}] ${player.name}`,
  }));

  const draftLockDate = new Date("2026-04-23T20:00:00-04:00");
  const isLocked = new Date() > draftLockDate;

  console.log("Loaded top players:", topPlayers);
  console.log("Dropdown options:", playerOptions);

  const handlePickChange = (index, playerName) => {
    const current = picks[index];
    const existingIndex = picks.findIndex((p, i) => p === playerName && i !== index);

    if (existingIndex !== -1) {
      setPlayerConflict({
        player: playerName,
        fromIndex: existingIndex,
        toIndex: index,
        currentPlayerInSlot: current
      });
      setShowPlayerModal(true);
    } else {
      const updated = [...picks];
      updated[index] = playerName;
      setPicks(updated);
    }
  };

  const handleTeamSelect = (index, newTeam) => {
    const currentTeam = teams[index];
    const existingIndex = teams.findIndex((t, i) => t === newTeam && i !== index);

    if (existingIndex !== -1) {
      setTeamConflict({
        team: newTeam,
        fromIndex: existingIndex,
        toIndex: index,
        currentTeamInSlot: currentTeam
      });
      setShowTeamModal(true);
      return;
    }

    const updated = [...teams];
    updated[index] = newTeam;
    setTeams(updated);
  };

  const restoreSubmittedPicks = async () => {
    if (!user) {
      alert("Please sign in to restore picks.");
      return;
    }

    const confirm = window.confirm(
      "⚠️ This will overwrite your current picks with your last submitted ones. Do you want to continue?"
    );
    if (!confirm) return;

    try {
      const userDocRef = doc(db, "users", user.email);
      const userDoc = await getDoc(userDocRef);

      if (!userDoc.exists()) {
        alert("⚠️ No saved data found for this account.");
        return;
      }

      const data = userDoc.data();
      console.log("🔄 Restore data:", data);

      if (
        !Array.isArray(data.picks_2026) ||
        !Array.isArray(data.teams_2026) ||
        data.picks_2026.length === 0 ||
        data.teams_2026.length === 0
      ) {
        alert("⚠️ You don’t have any submitted picks to restore yet.");
        return;
      }

      setPicks(data.picks_2026);
      setTeams(data.teams_2026);
      alert("✅ Submitted picks restored!");
    } catch (err) {
      console.error("❌ Restore error:", err);
      alert("Something went wrong while restoring picks.");
    }
  };

  const handleDownload = async () => {
    const canvas = await html2canvas(shareRef.current);
    const link = document.createElement('a');
    link.download = 'my-picks.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  };

  const handleCopy = async () => {
    const canvas = await html2canvas(shareRef.current);
    canvas.toBlob(async (blob) => {
      try {
        await navigator.clipboard.write([
          new ClipboardItem({ 'image/png': blob })
        ]);
        alert('📋 Image copied to clipboard!');
      } catch (err) {
        alert('❌ Copy failed. Try downloading instead.');
        console.error(err);
      }
    });
  };

  return (
    <>
      <div className="sticky top-0 bg-white z-40 flex justify-center py-2 shadow-sm border-b">
        <Link to="/players" className="text-[#003f8f] font-semibold hover:underline">
          🔍 View Player Info
        </Link>
      </div>

      <div className="flex flex-wrap justify-end gap-4 mb-4">
        <button
          onClick={() => {
            if (window.confirm("Are you sure you want to reset all player picks? This cannot be undone.")) {
              setPicks(Array(32).fill(''));
              localStorage.removeItem('draftPicks_temp');
            }
          }}
          className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
        >
          Reset Picks
        </button>

        <button
          onClick={() => {
            if (window.confirm("Are you sure you want to reset the draft order teams? This cannot be undone.")) {
              setTeams(initialDraftOrder);
              localStorage.removeItem('draftTeams_temp');
            }
          }}
          className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
        >
          Reset Teams
        </button>

        <button
          onClick={restoreSubmittedPicks}
          className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded"
        >
          Restore Submitted Picks
        </button>
      </div>

      <div className="space-y-4">
        {teams.map((team, i) => (
          <div key={i} className="bg-white p-4 shadow rounded flex flex-col md:flex-row gap-4">
            <div className="w-full md:w-1/2">
              <label className="block text-sm font-medium mb-1">#{i + 1} Team</label>
              <Select
                className={`w-full ${!teams[i] ? 'border border-red-500' : ''}`}
                value={teamOptions.find(opt => opt.value === teams[i]) || null}
                onChange={(opt) => handleTeamSelect(i, opt.value)}
                options={teamOptions}
                isSearchable
                formatOptionLabel={(opt, { context }) =>
                  context === 'menu' ? opt.label : opt.value
                }
              />
              <div className="text-xs text-gray-500 mt-1">
                Needs: {teamNeeds[teams[i]] ? teamNeeds[teams[i]].join(', ') : 'N/A'}
              </div>
            </div>

            <div className="w-full md:w-1/2">
              <label className="block text-sm font-medium mb-1">Pick</label>
              <Select
                className={`w-full ${!picks[i] ? 'border border-red-500' : ''}`}
                options={playerOptions}
                value={playerOptions.find(p => p.value === picks[i]) || null}
                placeholder="-- Select Player --"
                isClearable
                isDisabled={isLocked}
                onChange={(selected) => {
                  if (!selected || !selected.value) {
                    const newPicks = [...picks];
                    newPicks[i] = '';
                    setPicks(newPicks);
                    return;
                  }

                  const playerName = selected.value;
                  const existingIndex = picks.findIndex((p, idx) => p === playerName && idx !== i);
                  const currentPlayerInSlot = picks[i];

                  if (existingIndex !== -1) {
                    setPlayerConflict({
                      player: playerName,
                      fromIndex: existingIndex,
                      toIndex: i,
                      currentPlayerInSlot,
                    });
                    setShowPlayerModal(true);
                  } else {
                    const newPicks = [...picks];
                    newPicks[i] = playerName;
                    setPicks(newPicks);
                  }
                }}
                formatOptionLabel={(option, { context }) => {
                  console.log("Pick", i + 1, "->", picks[i]);
                  const player = topPlayers.find(p => p.name === option.value);
                  const isPicked = picks.includes(option.value);

                  if (!player) return option.label;

                  if (context === 'menu') {
                    return (
                      <div
                        className={`cursor-pointer flex items-center justify-between ${isPicked ? 'opacity-40' : ''}`}
                      >
                        <div>
                          <span className="font-medium">
                            #{player.rank} [{player.position}
                            {player.positionRank ? ` #${player.positionRank}` : ''}] {player.name}
                          </span>
                        </div>
                        {isPicked && <span className="text-red-500 text-sm ml-2">❌ Picked</span>}
                      </div>
                    );
                  }

                  return player.name;
                }}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 text-center flex flex-col md:flex-row gap-4 justify-center"></div>

      {!user && (
        <div className="text-center mb-4 text-sm text-red-600 font-semibold">
          🔐 Please sign in or sign up to save your picks.
        </div>
      )}

      {!isLocked && (
        <div className="mt-8 text-center">
          <button
            onClick={() => {
              if (!user) {
                alert("Please sign in or create an account to save your picks.");
                return;
              }

              const userDocRef = doc(db, "users", user.email);
              setDoc(userDocRef, {
                picks_2026: picks,
                teams_2026: teams,
                submittedAt_2026: serverTimestamp()
              }, { merge: true })
                .then(() => {
                  alert("✅ Picks submitted successfully!");
                  setSubmittedData({ picks, teams });
                })
                .catch((err) => {
                  console.error("❌ Error saving picks:", err);
                  alert("Error submitting picks. Please try again.");
                });
            }}
            className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded text-lg"
          >
            Submit Picks
          </button>

          <div className="mt-2 text-sm text-center">
            {user ? (
              JSON.stringify(picks) !== JSON.stringify(submittedData.picks) ||
              JSON.stringify(teams) !== JSON.stringify(submittedData.teams) ? (
                <p className="text-yellow-600 italic">
                  ⚠️ Your updates are saved but haven’t been submitted yet.
                </p>
              ) : (
                <p className="text-green-600 italic">
                  ✅ Your picks have been submitted and are up to date.
                </p>
              )
            ) : (
              <p className="text-gray-600">Your picks are saved locally in this browser.</p>
            )}
          </div>
        </div>
      )}

      {showPlayerModal && playerConflict && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-md max-w-sm w-full">
            <h2 className="text-lg font-bold mb-2">⚠️ Player Already Picked</h2>
            <p className="mb-4">
              {playerConflict.player} is already picked at #{playerConflict.fromIndex + 1}.
              {playerConflict.currentPlayerInSlot && (
                <> This spot already has <strong>{playerConflict.currentPlayerInSlot}</strong>.</>
              )}
            </p>

            <div className="flex flex-wrap justify-end gap-2">
              {playerConflict.currentPlayerInSlot && (
                <button
                  onClick={() => {
                    const updated = [...picks];
                    const temp = updated[playerConflict.toIndex];
                    updated[playerConflict.toIndex] = playerConflict.player;
                    updated[playerConflict.fromIndex] = temp;
                    setPicks(updated);
                    setShowPlayerModal(false);
                  }}
                  className="bg-yellow-400 px-3 py-1 rounded"
                >
                  🔁 Swap
                </button>
              )}

              <button
                onClick={() => {
                  const updated = [...picks];
                  updated[playerConflict.fromIndex] = '';
                  updated[playerConflict.toIndex] = playerConflict.player;
                  setPicks(updated);
                  setShowPlayerModal(false);
                }}
                className="bg-blue-500 text-white px-3 py-1 rounded"
              >
                🔄 Move Here (Clear Old)
              </button>

              <button
                onClick={() => setShowPlayerModal(false)}
                className="bg-gray-300 px-3 py-1 rounded"
              >
                ❌ Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showTeamModal && teamConflict && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-md max-w-sm w-full">
            <h2 className="text-lg font-bold mb-2">⚠️ Team Already Used</h2>
            <p className="mb-4">
              {teamConflict.team} is already selected at pick #{teamConflict.fromIndex + 1}.
              {teamConflict.currentTeamInSlot && (
                <> This spot already has <strong>{teamConflict.currentTeamInSlot}</strong>.</>
              )}
            </p>

            <div className="flex flex-wrap justify-end gap-2">
              {teamConflict.currentTeamInSlot && (
                <button
                  onClick={() => {
                    const updated = [...teams];
                    const temp = updated[teamConflict.toIndex];
                    updated[teamConflict.toIndex] = teamConflict.team;
                    updated[teamConflict.fromIndex] = temp;
                    setTeams(updated);
                    setShowTeamModal(false);
                    setTeamConflict(null);
                  }}
                  className="bg-yellow-400 px-3 py-1 rounded"
                >
                  🔁 Swap
                </button>
              )}

              <button
                onClick={() => {
                  const updated = [...teams];
                  updated[teamConflict.fromIndex] = initialDraftOrder[teamConflict.fromIndex];
                  updated[teamConflict.toIndex] = teamConflict.team;
                  setTeams(updated);
                  setShowTeamModal(false);
                  setTeamConflict(null);
                }}
                className="bg-blue-600 text-white px-3 py-1 rounded"
              >
                🔄 Replace
              </button>

              <button
                onClick={() => {
                  const updated = [...teams];
                  updated[teamConflict.toIndex] = teamConflict.team;
                  setTeams(updated);
                  setShowTeamModal(false);
                  setTeamConflict(null);
                }}
                className="bg-green-600 text-white px-3 py-1 rounded"
              >
                ➕ Add Another Pick
              </button>

              <button
                onClick={() => {
                  setShowTeamModal(false);
                  setTeamConflict(null);
                }}
                className="bg-gray-300 px-3 py-1 rounded"
              >
                ❌ Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}









function Summary({ picks, teams }) {
  const shareRef = useRef(null);

  const handleDownload = async () => {
    const canvas = await html2canvas(shareRef.current);
    const link = document.createElement('a');
    link.download = 'my-picks.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  };

  const handleCopy = async () => {
    const canvas = await html2canvas(shareRef.current);
    canvas.toBlob(async (blob) => {
      try {
        await navigator.clipboard.write([
          new ClipboardItem({ 'image/png': blob })
        ]);
        alert('📋 Copied to clipboard!');
      } catch (err) {
        alert('❌ Copy failed. Try downloading instead.');
      }
    });
  };

  return (
    <div className="max-w-3xl mx-auto p-4">
      {/* Share Buttons */}
      <div className="flex justify-center flex-wrap gap-4 mt-4">
  <button
    onClick={handleDownload}
    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
  >
    ⬇️ Download
  </button>
  <button
    onClick={handleCopy}
    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
  >
    📋 Copy Image
  </button>
  <button
    onClick={() => {
      navigator.clipboard.writeText("https://DraftChallenge.app");
      alert("✅ App link copied to clipboard!");
    }}
    className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
  >
    📎 Copy App Link
  </button>
</div>


      {/* Shareable Summary Content */}
      <div
        ref={shareRef}
        className="p-4 sm:p-6 bg-white shadow rounded-xl space-y-4"
      >
        <h1 className="text-lg sm:text-xl font-bold text-center text-[#003f8f] mb-2">
          📋 My 2026 NFL Draft Picks
        </h1>

        {teams.map((team, i) => {
          const playerName = picks[i]?.trim();
          const player = topPlayers.find(p => p.name.toLowerCase() === playerName?.toLowerCase());

          return (
            <div
              key={i}
              className="flex flex-col sm:flex-row justify-between border-b pb-2 text-sm sm:text-base"
            >
              <div className="font-semibold text-[#003f8f]">#{i + 1} – {team}</div>
              <div className="text-gray-700">
                {playerName
                  ? `${playerName}${player?.school ? ` (${player.school})` : ''}`
                  : '—'}
              </div>
            </div>
          );
        })}

        <div className="text-center mt-6 text-xs sm:text-sm text-gray-500">
          Made with 💡 at <a href="https://DraftChallenge.app" className="underline text-blue-600" target="_blank" rel="noopener noreferrer">DraftChallenge.app</a>
        </div>
      </div>
    </div>
  );
}










const pastLeaderboard2025 = [
  { rank: 1, username: "DynamicD", score: 118 },
  { rank: 2, username: "Jeffreywall", score: 114 },
  { rank: 3, username: "James55330", score: 103 },
  { rank: 4, username: "tonyfrank03", score: 101 },
  { rank: 5, username: "AI mock draft", score: 93 },
  { rank: 6, username: "Fubu01082", score: 91 },
  { rank: 7, username: "levitation", score: 88 },
  { rank: 8, username: "Keegan", score: 84 },
  { rank: 9, username: "Jungm012", score: 80 },
  { rank: 10, username: "MADski36", score: 77 },
  { rank: 11, username: "Wyattfiecke", score: 74 },
  { rank: 12, username: "Dtrean", score: 67 },
  { rank: 13, username: "tjhitt64", score: 66 },
  { rank: 14, username: "Mmoore2", score: 63 },
  { rank: 15, username: "Purple People Eaters", score: 62 },
  { rank: 16, username: "Zach M", score: 59 },
  { rank: 17, username: "blackws6ta", score: 57 },
  { rank: 18, username: "Kevinholker", score: 51 },
  { rank: 19, username: "Big Poppa", score: 51 },
  { rank: 20, username: "WrongAnswers", score: 40 },
];
function Leaderboard({ user }) {
  const [scores, setScores] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [selectedYear, setSelectedYear] = useState("2026");
  const draftLockDate = new Date("2026-04-23T20:00:00-04:00");
const isLocked = new Date() > draftLockDate;

if (!user) {
    return (
      <div className="text-center p-6 text-red-600 font-medium">
        🚫 Please sign in to view the leaderboard.
      </div>
    );
  }

  useEffect(() => {
    const fetchScores = async () => {
      const usersSnapshot = await getDocs(collection(db, "users"));
      const resultsSnapshot = await getDocs(collection(db, "realResults_2026"));
      const realResults = resultsSnapshot.docs.map(doc => doc.data());

      const userList = [];

      for (const docSnap of usersSnapshot.docs) {
  const data = docSnap.data();

  const currentPicks = data.picks_2026 || [];
  const currentTeams = data.teams_2026 || [];

  if (!currentPicks.length || !currentTeams.length) continue;

  const picks = currentPicks.map((player, i) => ({
    player,
    pickNumber: i + 1,
    team: currentTeams[i] || '',
  }));

  const score = calculateScore(picks, realResults);
  const username = data.username || docSnap.id.split('@')[0];
  userList.push({ username, email: docSnap.id, score });
}


      userList.sort((a, b) => b.score - a.score);
      setScores(userList);
    };

    fetchScores();
  }, []);

  const handleViewUser = async (email) => {
    const userDoc = await getDoc(doc(db, "users", email));
    const data = userDoc.data();
    const resultsSnapshot = await getDocs(collection(db, "realResults_2026"));
    const realResults = resultsSnapshot.docs.map(doc => doc.data());

    const currentPicks = data.picks_2026 || [];
const currentTeams = data.teams_2026 || [];

const picks = currentPicks.map((player, i) => ({
  player,
  pickNumber: i + 1,
  team: currentTeams[i] || '',
}));

    const breakdown = picks.map(pick => {
      const actual = realResults.find(r => r.player === pick.player);
      const score = calculateScore([pick], actual ? [actual] : []);
      return { ...pick, score };
    });

    setUserDetails({ username: data.username, picks: breakdown });
    setSelectedUser(email);
  };
  

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">{selectedYear === "2026" ? "Current" : "2025"} Leaderboard</h2>
      <div className="mb-4">
  <button
    onClick={() => setSelectedYear("2026")}
    className={`mr-2 px-4 py-2 rounded ${
      selectedYear === "2026" ? "bg-blue-600 text-white" : "bg-gray-200"
    }`}
  >
    Current
  </button>

  <button
    onClick={() => setSelectedYear("2025")}
    className={`px-4 py-2 rounded ${
      selectedYear === "2025" ? "bg-blue-600 text-white" : "bg-gray-200"
    }`}
  >
    2025
  </button>
</div>

{isLocked ? (
  <>
    <table className="min-w-full bg-white shadow-md rounded">
  <thead>
    <tr className="bg-gray-100 text-left">
      <th className="py-2 px-4">Rank</th>
      <th className="py-2 px-4">Username</th>
      <th className="py-2 px-4">Score</th>
      <th className="py-2 px-4">View</th>
    </tr>
  </thead>
  <tbody>
    {(selectedYear === "2025" ? pastLeaderboard2025 : scores).map((user, i) => (
      <tr key={user.email} className="border-t">
        <td className="py-2 px-4">{i + 1}</td>
        <td className="py-2 px-4">{user.username}</td>
        <td className="py-2 px-4">{user.score}</td>
        <td className="py-2 px-4">
  {selectedYear === "2026" ? (
    <button
      onClick={() => handleViewUser(user.email)}
      className="text-blue-500 hover:underline text-sm"
    >
      View Picks
    </button>
  ) : (
    <span className="text-gray-400 text-sm">—</span>
  )}
</td>
      </tr>
    ))}
  </tbody>
</table>


{selectedUser && userDetails && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div className="bg-white p-6 rounded shadow-md max-w-lg w-full max-h-[80vh] relative overflow-y-auto">
      <button
        onClick={() => {
          setSelectedUser(null);
          setUserDetails(null);
        }}
        className="absolute top-3 right-4 text-sm text-blue-600 hover:underline"
      >
        Close ✕
      </button>

      <h3 className="text-xl font-bold mb-4 mt-6">📝 {userDetails.username}'s Picks</h3>
      <ul className="space-y-2 text-sm">
        {userDetails.picks.map((pick, i) => (
          <li key={i} className="border p-2 rounded">
            <strong>#{pick.pickNumber}</strong> — <span className="font-medium">{pick.team}</span> selects <span className="text-[#003f8f] font-semibold">{pick.player}</span>
            {pick.score !== undefined && (
              <span className="ml-2 text-green-600 font-semibold">+{pick.score}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  </div>
)}


  </>
) : (
  <p className="text-center text-gray-600 mt-8">
    🔒 Picks and scores will be visible after the draft starts.
  </p>
)}

    </div>
  );
}












function Admin() {
  const [adminKey, setAdminKey] = useState('');
  const [accessGranted, setAccessGranted] = useState(false);
  const [realResults, setRealResults] = useState([]);
  const [pickNumber, setPickNumber] = useState('');
  const [team, setTeam] = useState(null);
  const [player, setPlayer] = useState(null);
  const [userCount, setUserCount] = useState(null);

  const allTeams = [
  "Las Vegas Raiders",
  "New York Jets",
  "Arizona Cardinals",
  "Tennessee Titans",
  "New York Giants",
  "Cleveland Browns",
  "Washington Commanders",
  "New Orleans Saints",
  "Kansas City Chiefs",
  "Miami Dolphins",
  "Dallas Cowboys",
  "Los Angeles Rams",
  "Baltimore Ravens",
  "Tampa Bay Buccaneers",
  "Detroit Lions",
  "Minnesota Vikings",
  "Carolina Panthers",
  "Pittsburgh Steelers",
  "Los Angeles Chargers",
  "Philadelphia Eagles",
  "Chicago Bears",
  "Buffalo Bills",
  "San Francisco 49ers",
  "Houston Texans",
  "New England Patriots",
  "Seattle Seahawks",

  "Atlanta Falcons",
  "Cincinnati Bengals",
  "Denver Broncos",
  "Green Bay Packers",
  "Indianapolis Colts",
  "Jacksonville Jaguars"
];

  const teamOptions = allTeams.map(team => ({ value: team, label: team }));
  const playerOptions = topPlayers.map(p => ({ value: p.name, label: `#${p.rank} ${p.name}` }));

  useEffect(() => {
    const fetchResults = async () => {
      const snapshot = await getDocs(collection(db, "realResults_2026"));
      const sorted = snapshot.docs.map(doc => doc.data()).sort((a, b) => a.pickNumber - b.pickNumber);
      setRealResults(sorted);
    };
    fetchResults();
  }, []);

  useEffect(() => {
    const fetchUserCount = async () => {
      try {
        const snapshot = await getDocs(collection(db, "users"));
        setUserCount(snapshot.size);
      } catch (error) {
        console.error("Error fetching user count:", error);
      }
    };
    fetchUserCount();
  }, []);

  const correctKey = 'mm';

  const handleAccess = () => {
    if (adminKey === correctKey) {
      setAccessGranted(true);
    } else {
      alert('Incorrect key');
    }
  };

  const handleDeletePick = async (pickNumber) => {
    try {
      await deleteDoc(doc(db, "realResults_2026", `pick${pickNumber}`));
      setRealResults((prev) => prev.filter((r) => r.pickNumber !== pickNumber));
      alert("✅ Pick deleted.");
    } catch (err) {
      console.error("Error deleting pick:", err);
      alert("❌ Failed to delete pick.");
    }
  };

  if (!accessGranted) {
    return (
      <div className="max-w-sm mx-auto">
        <h2 className="text-xl font-semibold mb-2">Admin Login</h2>
        <input
          type="password"
          placeholder="Enter Admin Key"
          className="border p-2 w-full mb-2 rounded"
          value={adminKey}
          onChange={(e) => setAdminKey(e.target.value)}
        />
        <button onClick={handleAccess} className="bg-blue-500 text-white px-4 py-2 rounded">
          Enter
        </button>
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Admin Panel</h2>

      <div className="mb-6 bg-white border p-4 rounded shadow">
        <h3 className="text-lg font-semibold">📊 Total Users Signed Up</h3>
        <p className="text-2xl font-bold text-green-600">
          {userCount !== null ? userCount : "Loading..."}
        </p>
      </div>

      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Enter Real Draft Picks</h3>

        <form
          onSubmit={async (e) => {
            e.preventDefault();
            if (!pickNumber || !team || !player) {
              alert('Please fill out all fields');
              return;
            }

            const updatedResults = [...realResults];
            const index = updatedResults.findIndex(r => r.pickNumber === parseInt(pickNumber));
            if (index !== -1) {
              updatedResults[index] = { pickNumber: parseInt(pickNumber), team, player };
            } else {
              updatedResults.push({ pickNumber: parseInt(pickNumber), team, player });
            }

            setRealResults(updatedResults);
            setPickNumber('');
            setTeam(null);
            setPlayer(null);

            try {
              await setDoc(doc(db, "realResults_2026", `pick${pickNumber}`), {
                pickNumber: parseInt(pickNumber),
                team,
                player
              });
              alert('✅ Pick saved to Firestore!');
            } catch (err) {
              console.error("Error saving to Firestore:", err);
              alert('❌ Error saving pick. Try again.');
            }
          }}
          className="space-y-2"
        >
          <input
            type="number"
            placeholder="Pick #"
            className="w-full p-2 border rounded"
            value={pickNumber}
            onChange={(e) => setPickNumber(e.target.value)}
          />

          <Select
            options={teamOptions}
            value={teamOptions.find(opt => opt.value === team) || null}
            onChange={(opt) => setTeam(opt.value)}
            placeholder="Select Team"
            className="w-full"
            />
  
            <Select
              options={playerOptions}
              value={playerOptions.find(opt => opt.value === player) || null}
              onChange={(opt) => setPlayer(opt.value)}
              placeholder="Select Player"
              isSearchable
              className="w-full"
            />
  
            <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded">
              Save Pick
            </button>
          </form>
  
          <h4 className="font-semibold mt-4">Saved Picks:</h4>
          <ul className="list-disc pl-5 text-sm">
            {realResults.map((r, i) => (
              <li key={i} className="flex justify-between items-center">
                <span>#{r.pickNumber} - {r.team} → {r.player}</span>
                <button
                  onClick={() => handleDeletePick(r.pickNumber)}
                  className="ml-2 text-red-600 hover:underline text-xs"
                >
                  Delete
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}



